import { Helmet } from 'react-helmet-async';
import { Container, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Logo from '../../vendor/oli-sharEnergy.png';
import SignInComponent from '../../components/auth/SignIn';
import { useTranslation } from 'react-i18next';
function SignIn() {
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);
  const [urlVal, setUrlVal] = useState(window.location.href);

  const [showTranslator, setShowTranslator] = useState(false);
  const changeLanguageHandler = (languageValue) => {
    i18n.changeLanguage(languageValue);
    setCurrentLang(languageValue);
  };

  useEffect(() => {
    setUrlVal(window.location.href);
  }, []);

  useEffect(() => {
    if (
      window.location.href.includes('localhost') ||
      window.location.href.includes('dev') ||
      window.location.href.includes('int')
    ) {
      setShowTranslator(true);
    }
  }, [urlVal]);

  return (
    <>
      {showTranslator == true ? (
        <div
          style={{
            float: 'right',
            width: '100%',
            textAlign: 'right',
            position: 'fixed',
            top: 0,
            marginRight: '10px',
            backgroundColor: 'transparent',
          }}
        >
          <div
            onClick={() => changeLanguageHandler('en')}
            style={{
              float: 'right',
              cursor: 'pointer',
              margin: '5px',
              color: currentLang == 'en' ? '#7faa40' : 'grey',
            }}
          >
            En
          </div>
          <div
            onClick={() => changeLanguageHandler('de')}
            style={{
              float: 'right',
              cursor: 'pointer',
              margin: '5px',
              color: currentLang != 'en' ? '#7faa40' : 'grey',
            }}
          >
            De
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <Helmet title="Login" />
      <img src={Logo} alt="logo" width={200} height={189} />
      <Container maxWidth="xs">
        <Typography
          component="h1"
          variant="h3"
          align="center"
          sx={{ mt: 8, mb: 6 }}
        >
          {t('LBLLogin')}
        </Typography>
        <SignInComponent />
      </Container>
    </>
  );
}

export default SignIn;
